import axios from 'axios';
import swal from 'sweetalert';

export interface ActionValuePayload {
    action: 'include' | 'exclude' | 'all' | '';
    value: string[];
}

export interface FeePayload {
    checked: boolean;
    value?: number;
}

export interface SalesPromotionSearchPayload {
    dateRange?: {
        type: 'specific' | 'no_restriction';
        from?: string;
        to?: string;
    };
    departureDateRange?: {
        type: 'specific' | 'no_restriction';
        from?: string;
        to?: string;
    };
    consortium?: ActionValuePayload;
    agencyLocation?: ActionValuePayload;
    agency?: ActionValuePayload;
    agent?: ActionValuePayload;
    origin?: ActionValuePayload;
    destination?: ActionValuePayload;
    brandCode?: ActionValuePayload;
    airline?: ActionValuePayload;
    bookingChannel?: string[];
    supplier?: string[];
    tripType?: string[];
    cabinType?: string[];
    voidAllowed?: boolean;
    refundAllowed?: boolean;
    reissueAllowed?: boolean;
    ticketingFee?: FeePayload;
    voidFee?: FeePayload;
    refundFee?: FeePayload;
    reissueFee?: FeePayload;
    bookingFee?: FeePayload;
    merchantFee?: FeePayload;
    pubFareCommission?: FeePayload;
    lowestOfOrMarkup?: FeePayload;
    defaultMarkup?: FeePayload;
    sellPubAtCost?: boolean;
    isLoyaltyPromotions?: boolean;
    promotionCode?: string;
    loyaltyPoints?: number | string;
    overrideNoProfitNoPoints?: boolean;
}

export interface fetchAllSalesPromotionPayloadInterface {
    agencyInclusion?: string;
    showAll?: boolean;
    fees?: boolean;
    consortiumInclusion?: string;
    agencyLocationInclusion?: string;
    tripType?: string;
    bookingChannel?: string;
    supplier?: string;
    origin?: string;
    destination?: string;
    agentExclusion?: string;
    naID?: string;
}

export type FetchAllSalesPromotionPayload = fetchAllSalesPromotionPayloadInterface | SalesPromotionSearchPayload | { naID: string };

export const postSearchByCriteria = async (
        payload: FetchAllSalesPromotionPayload,
        setterFunction: any,
        options?: { limit?: number; offset?: number }
    ) => {
        const limit = options?.limit ?? 100;
        const offset = options?.offset ?? 0;
        let url: any = `${process.env.REACT_APP_BASE_URL}/salesPromotion/searchByCriteria`;
        const requestOptions: any = {
            headers: {
                "Content-type": "application/json",
            },
        };
        const body = { ...payload, limit, offset };
        let postFetchAllSalesPromotion: any;
        try {
            postFetchAllSalesPromotion = await axios.post(url, body, requestOptions);
            if (postFetchAllSalesPromotion?.error) {
                swal({
                    text: "Fetching Failed!",
                    icon: "error",
                });
            }
            return postFetchAllSalesPromotion?.data;
        } catch (error) {
            console.error(error);
            setterFunction(false);
            swal({
                text: "Failed",
                icon: "error"
            });
            return [];
        }
    };